import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { CreateClientDocumentAttachmentDto } from "../models/client/createClientDocumentAttachment";
import { DeleteCustomerAddressRequestDto } from "../models/client/deleteCustomerAddressRequestDto";
import { DeleteCustomerAddressResponseDto } from "../models/client/deleteCustomerAddressResponseDto";
import { DeleteCustomerContactResponseDto } from "../models/client/deleteCustomerContactResponseDto";
import { Client } from "../models/client/details/client";
import { ClientDto } from "../models/client/details/clientDto";
import { ClientTransactions } from "../models/client/details/clientTransactions";
import { OpenInvoiceAmountTilesDto } from "../models/client/details/openInvoiceAmountTilesDto";
import { UpdateCustomerPODto } from "../models/client/details/updateCustomerPODto";
import { GenericResponseDto } from "../models/generic-response.dto";
import { ClientContract } from "../models/client/details/clientContract";
import { FileUploadDto } from "../models/shared/fileUploadDto";
import { OpenInvoiceAmountsDto } from "../models/client/details/openInvoiceAmountsDto";

@Injectable({
  providedIn: "root",
})
export class ClientDetailsService {
  private clientManagementBaseURL = environment.baseUrl + "/ClientManagement";
  private fileManagementBaseURL = environment.baseUrl + "/fileManagement";
  private saleOrderManagementBaseURL =
    environment.baseUrl + "/SalesOrderManagement";

  private d365SynchroniserBaseURL = environment.baseUrl + "/D365Synchroniser";
  private reportBaseURL = environment.baseUrl + "/Reports";
  constructor(private _http: HttpClient) {}

  getClientInformation(
    accountnumber: string
  ): Observable<GenericResponseDto<ClientDto>> {
    return this._http.get<GenericResponseDto<ClientDto>>(
      this.clientManagementBaseURL +
        `/GetCustomerByAccountNumber?accountNumber=${accountnumber}&partyNumber=${accountnumber}`
    );
  }

  getClientContractInformation(
    accountnumber: string
  ): Observable<GenericResponseDto<ClientContract>> {
    return this._http.get<GenericResponseDto<ClientContract>>(
      this.clientManagementBaseURL +
        `/GetClientContractsByAccountNumber?accountNumber=${accountnumber}`
    );
  }

  // creatClientContract(
  //   payload: ClientContract[]
  // ): Observable<GenericResponseDto<ClientContract[]>> {
  //   return this._http.post<GenericResponseDto<ClientContract[]>>(
  //     this.clientManagementBaseURL + "/AddClientContracts",
  //     payload
  //   );
  // }

  // getClientCreditCardInformation(payload: any) {
  //   return this._http.post<GenericResponseDto<any>>(
  //     environment.baseUrl + "/",
  //     payload
  //   );
  // }

  // getCommissionSetupInformation(payload: any) {
  //   return this._http.post<GenericResponseDto<any>>(
  //     environment.baseUrl + "/",
  //     payload
  //   );
  // }

  // getMiscellaneousInformation(payload: any) {
  //   return this._http.post<GenericResponseDto<any>>(
  //     environment.baseUrl + "/",
  //     payload
  //   );
  // }

  UpdateContractClientData(payload: ClientContract) {
    return this._http.put<GenericResponseDto<ClientContract>>(
      this.clientManagementBaseURL + "/UpdateClientContracts",
      payload
    );
  }

  UpdateCustomerPOData(payload: UpdateCustomerPODto) {
    return this._http.post<GenericResponseDto<boolean>>(
      this.clientManagementBaseURL + "/UpdateCustomerPO",
      payload
    );
  }

  getContacttitleAttachmentUrl(
    fileObj: FileUploadDto[]
  ): Observable<GenericResponseDto<string>> {
    return this._http.post<GenericResponseDto<string>>(
      this.fileManagementBaseURL + "/upload",
      fileObj[0]
    );
  }
  getContacttitleSecondAttachmentUrl(
    fileObj: FileUploadDto[]
  ): Observable<GenericResponseDto<string>> {
    return this._http.post<GenericResponseDto<string>>(
      this.fileManagementBaseURL + "/upload",
      fileObj[1]
    );
  }

  UpdateClientSummaryData(payload: { client: Client }) {
    return this._http.post<GenericResponseDto<{ client: Client }>>(
      this.clientManagementBaseURL + "/UpdateClient",
      payload
    );
  }

  addClientSummaryAttachment(payload: CreateClientDocumentAttachmentDto) {
    return this._http.post<
      GenericResponseDto<CreateClientDocumentAttachmentDto>
    >(this.clientManagementBaseURL + "/CreateDocumentAttachment", payload);
  }

  openInvoiceAmountTiles(customerAccount: string) {
    return this._http.get<GenericResponseDto<OpenInvoiceAmountTilesDto>>(
      this.clientManagementBaseURL +
        `/OpenInvoiceAmountTiles?customerAccount=${customerAccount}`
    );
  }

  GetJNIDeletedRecordsFilter(
    odataFilter: string
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.get<GenericResponseDto<boolean>>(
      this.d365SynchroniserBaseURL +
        "/GetJNIDeletedRecordsFilter?odataFilter=" +
        odataFilter
    );
  }

  openInvoiceAmounts(customerAccount: string, type: number) {
    return this._http.get<GenericResponseDto<OpenInvoiceAmountsDto[]>>(
      this.clientManagementBaseURL +
        `/OpenInvoiceAmounts?customerAccount=${customerAccount}&type=${type}`
    );
  }

  getAvailableCredit(customerAccount: string) {
    return this._http.get<GenericResponseDto<ClientTransactions>>(
      this.clientManagementBaseURL +
        `/GetCustomerBalance?AccountNumber=${customerAccount}`
    );
  }

  IsCustomerPOFieldRequired(customerAccount: string) {
    return this._http.get<GenericResponseDto<boolean>>(
      this.clientManagementBaseURL +
        `/IsCustomerPOFieldRequired?accountNumber=${customerAccount}`
    );
  }

  getOpenOrder(customerAccount: string) {
    return this._http.get<GenericResponseDto<number>>(
      this.reportBaseURL + `/OpenOrders?CustomerAccount=${customerAccount}`
    );
  }

  getFYTDSales(customerAccount: string) {
    return this._http.get<GenericResponseDto<number>>(
      this.reportBaseURL + `/FYTDSales?CustomerAccount=${customerAccount}`
    );
  }

  deleteCustomerContact(payload: string[]) {
    return this._http.post<
      GenericResponseDto<DeleteCustomerContactResponseDto>
    >(this.clientManagementBaseURL + "/DeleteCustomerContact", payload);
  }

  deleteCustomerAddress(payload: DeleteCustomerAddressRequestDto) {
    return this._http.post<
      GenericResponseDto<DeleteCustomerAddressResponseDto>
    >(this.clientManagementBaseURL + "/DeleteCustomerAddress", payload);
  }
}
